import { useParams,useLocation } from "react-router-dom";
import { useCustomHistory } from "hooks";
import { useSelector } from "react-redux";
import * as ROUTE_CONSTANTS from "routes/constants";

const useDelivertPickupFn = () => {
  const params = useParams();
  const router = useCustomHistory();
  const { DomainType } = useSelector((state) => state.AppReducer);
  const location = useLocation();
  //go to settings
  const goToSettings = () => {
    let url = ROUTE_CONSTANTS.OUTLET_SETTINGS[1];
    if (params) {
      router(url, `/${params?.domainName}${url}`, DomainType);
    }
  };
  //go to login
  const goToLogin = () => {
    let url1 = ROUTE_CONSTANTS.OUTLET_LOGIN[1];
    router(url1, `/${params?.domainName}${url1}`, DomainType);
  };
  // view basket page
  const viewBasketPage = () => {
    let url = ROUTE_CONSTANTS.OUTLET_BASKET[1];
    if (params) {
      router(url, `/${params?.domainName}${url}`, DomainType);
    }
  };
  // go to home page
  const goToHomePage = () => {
    router("/", `/${params?.domainName}`, DomainType);
  };

  // go to store page
  const goToStorePage = ( ) => {
    let url = ROUTE_CONSTANTS.OUTLET_STORE[1];
    if (params) {
      router(url, `/${params?.domainName}${url}`, DomainType);
    }
  };

  return {
    goToSettings,
    goToLogin,
    viewBasketPage,
    goToHomePage,
    goToStorePage,
    storeUrl: {
      baseUrl: ROUTE_CONSTANTS.OUTLET_BASKET[1],
      url: `/${params?.domainName}${ROUTE_CONSTANTS.OUTLET_BASKET[1]}`,
    },
    homeUrl: {
      baseUrl: "/",
      url: `/${params?.domainName}`,
    },
    location,
    params,
    router,
    DomainType,
  };
};

export default useDelivertPickupFn
